import VideoName from "./VideoName";
import CreditBalance from "./CreditBalance";
import VideoSettingsDropdown from "./VideoSettingsDropdown";
import ExportVideoDialog from "./ExportVideoDialog/ExportVideoDialog";
import EditorBackNavigation from "./EditorBackNavigation";

export default function EditorNavbar() {
  return (
    <div className="flex flex-[0_0_64px] items-center self-stretch rounded-2xl bg-white px-3 shadow-card">
      <EditorBackNavigation />
      <div className="flex-1">
        <VideoName />
      </div>
      <CreditBalance />

      <ExportVideoDialog />
      <VideoSettingsDropdown />
    </div>
  );
}
